// removed by extract-text-webpack-plugin
module.exports = {"root":"crew__root--3mwPv","title":"crew__title--1t43A thinBigText","wrapper":"crew__wrapper--3el2C","patternOverlay":"crew__patternOverlay--1QrPG","scrollbarOuter":"crew__scrollbarOuter--3aOJ5","scrollbarInner":"crew__scrollbarInner--15Fjr","annotationWrapper":"crew__annotationWrapper--52RZz","annotationWrapperActive":"crew__annotationWrapperActive--xbehm crew__annotationWrapper--52RZz","sensor":"crew__sensor--2-14I","crewContainer":"crew__crewContainer--1GraB"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modules/Crew/crew.css
// module id = vOLZ
// module chunks = 0